export default __webpack_public_path__ + "static/media/Q8_1_resized.056490f4.jpg";